import { render, staticRenderFns } from "./ClinicListing.vue?vue&type=template&id=784d05d0"
import script from "./ClinicListing.vue?vue&type=script&lang=js"
export * from "./ClinicListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports